/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { NlpIntegrationGetLiveTopicsTopicByIdQueryResponse, NlpIntegrationGetLiveTopicsTopicByIdPathParams, NlpIntegrationGetLiveTopicsTopicById401, NlpIntegrationGetLiveTopicsTopicById403, NlpIntegrationGetLiveTopicsTopicById404 } from "../models/NlpIntegrationGetLiveTopicsTopicById";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { nlpIntegrationGetLiveTopicsTopicById } from "../axios/nlpIntegrationGetLiveTopicsTopicById";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const nlpIntegrationGetLiveTopicsTopicByIdQueryKey = (slug: NlpIntegrationGetLiveTopicsTopicByIdPathParams["slug"], topicId: NlpIntegrationGetLiveTopicsTopicByIdPathParams["topicId"]) => ["api-v2", { url: '/nlp-integration/v1/live-topics/:slug/topics/:topicId', params: {slug:slug,topicId:topicId} }] as const

export type NlpIntegrationGetLiveTopicsTopicByIdQueryKey = ReturnType<typeof nlpIntegrationGetLiveTopicsTopicByIdQueryKey>

export function nlpIntegrationGetLiveTopicsTopicByIdQueryOptions(slug: NlpIntegrationGetLiveTopicsTopicByIdPathParams["slug"], topicId: NlpIntegrationGetLiveTopicsTopicByIdPathParams["topicId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = nlpIntegrationGetLiveTopicsTopicByIdQueryKey(slug, topicId)
        return queryOptions<NlpIntegrationGetLiveTopicsTopicByIdQueryResponse, ResponseErrorConfig<NlpIntegrationGetLiveTopicsTopicById401 | NlpIntegrationGetLiveTopicsTopicById403 | NlpIntegrationGetLiveTopicsTopicById404>, NlpIntegrationGetLiveTopicsTopicByIdQueryResponse, typeof queryKey>({
         enabled: !!(slug&& topicId),
         queryKey,
         queryFn: async ({ signal }) => {
            return nlpIntegrationGetLiveTopicsTopicById(slug, topicId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Fetch a single topic by id for the given channel slug.
 * @summary Get topic by id
 * {@link /nlp-integration/v1/live-topics/:slug/topics/:topicId}
 */
export function useNlpIntegrationGetLiveTopicsTopicById<TData = NlpIntegrationGetLiveTopicsTopicByIdQueryResponse, TQueryData = NlpIntegrationGetLiveTopicsTopicByIdQueryResponse, TQueryKey extends QueryKey = NlpIntegrationGetLiveTopicsTopicByIdQueryKey>(slug: NlpIntegrationGetLiveTopicsTopicByIdPathParams["slug"], topicId: NlpIntegrationGetLiveTopicsTopicByIdPathParams["topicId"], options: 
{
  query?: Partial<QueryObserverOptions<NlpIntegrationGetLiveTopicsTopicByIdQueryResponse, ResponseErrorConfig<NlpIntegrationGetLiveTopicsTopicById401 | NlpIntegrationGetLiveTopicsTopicById403 | NlpIntegrationGetLiveTopicsTopicById404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? nlpIntegrationGetLiveTopicsTopicByIdQueryKey(slug, topicId)
         

         const query = useQuery({
          ...nlpIntegrationGetLiveTopicsTopicByIdQueryOptions(slug, topicId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<NlpIntegrationGetLiveTopicsTopicById401 | NlpIntegrationGetLiveTopicsTopicById403 | NlpIntegrationGetLiveTopicsTopicById404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}